module.exports = __webpack_public_path__ + "static/media/Alien League Bold-01.50660d57.svg";